import React, { useContext } from 'react';
import './TestimoniCard.scss';
import { AiFillStar } from "react-icons/ai";
import imageCoskun from '../../assets/newmonaassets/flags/image_comments_coskun.png';
import imageFethi from '../../assets/newmonaassets/flags/image_comments_fethi.png';
import imageAyca from '../../assets/newmonaassets/flags/image_comments_ayca.png';
import { LanguageContext } from '../../context/LanguageContext';
import OptimizedImage from '../OptimizedImage';

const TestimoniCard = ({testimonial}) => {
    const { t } = useContext(LanguageContext);
    const {name, description, rating} = testimonial;
   
    // İsme göre resim seçimi
    const getImage = (name) => {
        switch(name) {
            case "Coşkun Namlı":
            case "Robert Fox":
                return imageCoskun;
            case "Fethi Bayram":
            case "Albert Flores":
                return imageFethi;
            case "Ayça Çevik Özkan":
            case "Bessie Cooper":
                return imageAyca;
            default:
                return imageCoskun;
        }
    };

    const renderStars = () => {
        const stars = [];
        const fullStars = Math.floor(rating);
        const hasHalfStar = rating % 1 !== 0;
        
        // Dolu yıldızlar
        for (let i = 0; i < fullStars; i++) {
            stars.push(<li key={i}><AiFillStar className="filled" /></li>);
        }
        
        // Yarım yıldız
        if (hasHalfStar) {
            stars.push(<li key="half"><AiFillStar className="half-filled" /></li>);
        }
        
        // Boş yıldızlar
        const emptyStars = 5 - Math.ceil(rating);
        for (let i = 0; i < emptyStars; i++) {
            stars.push(<li key={`empty-${i}`}><AiFillStar className="empty" /></li>);
        }
        
        return stars;
    };

    return (
        <div className='col-lg-4 single-testimoni'>
            <div className="testimonial-card">
                <div className="testimonial-img">
                    <OptimizedImage src={getImage(name)} alt={t('altText.testimonial')} />
                </div>
                <div className="testimonial-text">
                    <h3>{name}</h3>
                    <p>{description}</p>
                </div>
                <ul className='testimonial-rating'>
                    {renderStars()}
                </ul>
            </div>
        </div>
    );
};

export default TestimoniCard;